import { Tooltip } from "@mui/material";
import { CardTitle } from "reactstrap";
//Topic Tiltes
const TopicNameTitleTextComponent = ({ title }: { title: string }) => {
  const isLong = title.length > 30;

  const textStyle: React.CSSProperties = isLong
    ? {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
        color: "#2d2d2d",
      }
    : {
        whiteSpace: "normal",
        wordBreak: "break-word",
        width: "100%",
        color: "#2d2d2d",
      };

  const TitleElement = (
    <h1 className="list-title" style={textStyle}>
      {title}
    </h1>
  );

  return (
    <div style={{ width: "100%" }}>
      {isLong ? (
        <Tooltip title={title} placement="top" arrow>
          {TitleElement}
        </Tooltip>
      ) : (
        TitleElement
      )}
    </div>
  );
};

//Course Card title
const CourseNameTitleTextComponent = ({ title }: { title: string }) => {
  const isLong = title.length > 30;

  const textStyle: React.CSSProperties = isLong
    ? {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
      }
    : {
        whiteSpace: "normal",
        wordBreak: "break-word",
        width: "100%",
      };

  const TitleElement = (
    <CardTitle
      tag="h5"
      style={{ margin: 0, width: "100%", minWidth: 0, overflow: "hidden" }}
    >
      <div style={textStyle}>{title}</div>
    </CardTitle>
  );

  return isLong ? (
    <Tooltip title={title} placement="top" arrow>
      <div style={{ width: "100%" }}>{TitleElement}</div>
    </Tooltip>
  ) : (
    TitleElement
  );
};

export { CourseNameTitleTextComponent, TopicNameTitleTextComponent };
